module.exports = __webpack_public_path__ + "img/c00_buildingtechphilosophy_Normal_ua.fdde32f3.webp";